// Translation: Account > Members > Members list > Invitation dialog (Turkish)
export default Object.freeze({
	actions: {
		cancel: 'İptal',
		invite: 'Davet et'
	},
	fields: {
		email: {
			label: 'E-posta adresi',
			placeholder: 'E-posta adresi girin'
		},
		role: {
			label: 'Rol'
		}
	},
	title: 'Takım üyesi davet et'
})
